// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"55767d39","453":"f3bb842a"}[chunkId] + ".chunk.js";
};